// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Buy Credit Page Styles */

.buy-credit-container {
  min-height: 100vh;
  background-color: #f9fafb;
}

.buy-credit-content {
  max-width: 32rem;
  margin: 0 auto;
  padding: 1.5rem 1rem;
}

.back-button {
  margin-bottom: 1rem;
  color: #2563eb;
  font-weight: 500;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: color 0.2s;
}

.back-button:hover {
  color: #1d4ed8;
}

.current-balance-card {
  text-align: center;
  margin-bottom: 1.5rem;
}

.current-balance-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
}

.current-balance-amount {
  font-size: 2.25rem;
  font-weight: 700;
  color: #10b981;
  margin-top: 0.5rem;
}

.demo-notice {
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.demo-notice-header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.demo-notice-icon {
  width: 1.25rem;
  height: 1.25rem;
  color: #60a5fa;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.demo-notice-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: #1e40af;
  margin: 0 0 0.25rem 0;
}

.demo-notice-text {
  font-size: 0.875rem;
  color: #1e40af;
  margin: 0;
}

.quick-amounts-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.quick-amount-button {
  padding: 0.75rem;
  text-align: center;
  border-radius: 0.5rem;
  border: 2px solid;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.quick-amount-button:not(.selected) {
  border-color: #d1d5db;
  color: #374151;
  background-color: #ffffff;
}

.quick-amount-button:not(.selected):hover {
  border-color: #9ca3af;
  background-color: #f9fafb;
}

.quick-amount-button.selected {
  border-color: #2563eb;
  background-color: #eff6ff;
  color: #1d4ed8;
}

.custom-amount-input {
  position: relative;
}

.dollar-sign {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  font-size: 0.875rem;
  pointer-events: none;
  z-index: 10;
}

.amount-input {
  padding-left: 1.75rem !important;
}

.purchase-summary {
  background-color: #f9fafb;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.summary-row:last-of-type {
  margin-bottom: 0;
}

.summary-label {
  color: #6b7280;
  font-size: 0.875rem;
}

.summary-value {
  font-weight: 600;
}

.summary-total-label {
  font-size: 1.125rem;
  font-weight: 600;
}

.summary-total-value {
  font-size: 1.125rem;
  font-weight: 700;
  color: #2563eb;
}

.summary-new-balance {
  font-size: 0.875rem;
  color: #6b7280;
  margin-top: 0.5rem;
}

.action-buttons {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.action-button {
  flex: 1 1;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;
}

.action-button.secondary {
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  color: #374151;
}

.action-button.secondary:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}

.action-button.primary {
  background-color: #2563eb;
  border: 1px solid #2563eb;
  color: #ffffff;
}

.action-button.primary:hover:not(:disabled) {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}

.action-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Buy Credit loading spinner */
.buy-credit-loading-spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.buy-credit-spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.security-notice {
  text-align: center;
  color: #6b7280;
  font-size: 0.75rem;
  line-height: 1.4;
}

.security-notice p {
  margin: 0.25rem 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/BuyCredit.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* Buy Credit Page Styles */\n\n.buy-credit-container {\n  min-height: 100vh;\n  background-color: #f9fafb;\n}\n\n.buy-credit-content {\n  max-width: 32rem;\n  margin: 0 auto;\n  padding: 1.5rem 1rem;\n}\n\n.back-button {\n  margin-bottom: 1rem;\n  color: #2563eb;\n  font-weight: 500;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: color 0.2s;\n}\n\n.back-button:hover {\n  color: #1d4ed8;\n}\n\n.current-balance-card {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.current-balance-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.current-balance-amount {\n  font-size: 2.25rem;\n  font-weight: 700;\n  color: #10b981;\n  margin-top: 0.5rem;\n}\n\n.demo-notice {\n  background-color: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.demo-notice-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.demo-notice-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  color: #60a5fa;\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n}\n\n.demo-notice-title {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #1e40af;\n  margin: 0 0 0.25rem 0;\n}\n\n.demo-notice-text {\n  font-size: 0.875rem;\n  color: #1e40af;\n  margin: 0;\n}\n\n.quick-amounts-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n\n.quick-amount-button {\n  padding: 0.75rem;\n  text-align: center;\n  border-radius: 0.5rem;\n  border: 2px solid;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.quick-amount-button:not(.selected) {\n  border-color: #d1d5db;\n  color: #374151;\n  background-color: #ffffff;\n}\n\n.quick-amount-button:not(.selected):hover {\n  border-color: #9ca3af;\n  background-color: #f9fafb;\n}\n\n.quick-amount-button.selected {\n  border-color: #2563eb;\n  background-color: #eff6ff;\n  color: #1d4ed8;\n}\n\n.custom-amount-input {\n  position: relative;\n}\n\n.dollar-sign {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6b7280;\n  font-size: 0.875rem;\n  pointer-events: none;\n  z-index: 10;\n}\n\n.amount-input {\n  padding-left: 1.75rem !important;\n}\n\n.purchase-summary {\n  background-color: #f9fafb;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.summary-row:last-of-type {\n  margin-bottom: 0;\n}\n\n.summary-label {\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.summary-value {\n  font-weight: 600;\n}\n\n.summary-total-label {\n  font-size: 1.125rem;\n  font-weight: 600;\n}\n\n.summary-total-value {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #2563eb;\n}\n\n.summary-new-balance {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-top: 0.5rem;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.action-button {\n  flex: 1;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.5rem;\n  font-weight: 500;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.action-button.secondary {\n  background-color: #ffffff;\n  border: 1px solid #d1d5db;\n  color: #374151;\n}\n\n.action-button.secondary:hover {\n  background-color: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.action-button.primary {\n  background-color: #2563eb;\n  border: 1px solid #2563eb;\n  color: #ffffff;\n}\n\n.action-button.primary:hover:not(:disabled) {\n  background-color: #1d4ed8;\n  border-color: #1d4ed8;\n}\n\n.action-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Buy Credit loading spinner */\n.buy-credit-loading-spinner {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.buy-credit-spinner {\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.security-notice {\n  text-align: center;\n  color: #6b7280;\n  font-size: 0.75rem;\n  line-height: 1.4;\n}\n\n.security-notice p {\n  margin: 0.25rem 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
